import { render, staticRenderFns } from "./R14.vue?vue&type=template&id=4827e3da"
import script from "./R14.vue?vue&type=script&lang=js"
export * from "./R14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports